// extracted by mini-css-extract-plugin
module.exports = {"button":"button-2BtCv","paper":"paper-XR-zR"};